/*

poornima    09/19/2022 2701127043 Fixed GAL- 122,127,128,130,161,163,170,171,173 bugs
sai krishna 10/06/2022 2701127043 Removed unecesarry console.log statements
sohel       10/17/2022 2701127043 Rule Group Fixed Reset Issue
Ashraf       11/01/2022 2701127043 Added optional chaining
akhila  11/14/2022 2701127043 fixed test loading bug
Sohel 11/17/2022 2701127043 reset Toast Message
Sohel 11/16/2022 2701127043 fixed Filter Save issue
madhu 11/17/2022 2701127043 added three properties in the initial state
Ashraf 11/18/2022 2701127043 fixed basic info data mapping
Ashraf 11/19/2022 2701127043 added functions for copy functionality
Ashraf 11/21/2022 2701127043 fixed loader issue for fetching rule data
Sohel 11/22/2022 2701127043 fixed filter page break issue
Ashraf 11/23/2022 2701127043 added reducer for overriding data handle
lalitha 11/23/2022 2701127043 fixed page break issue
Ashraf 11/24/2022 2701127043 mapping fetched id for formula rule
Saikrishna  11/29/2022  2701127043 Test API integration done
Akhila 11/29/2022 2701127043 Added resetTest result and fetchTestError for Calculation only in BRE formula
akhila 12/14/2022 2701127043 integrated formula save and get api
akhila 12/16/2022 2701127043 changed get api to post api
dilip 12/20/2022 2701127043 Operators API
Ashraf 01/04/2022 2701127043 fixed loader reset issue
Akhila 02/24/2023 2701127043 implemented preview file functionality in download configuration
Akhila 03/01/2023 2701127043 Added loader and download toast message for preview File
Sohel 03/10/2023 2701335619 Added Error Record in Action
Akhila 06/21/2023 2701335619 conditionally disable save and finish button on submission
*/

import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../../util/Rest';
import {fetchDownloadSuccess} from '../PreviewFileData';
import {DM_ACTIONS} from '../../../constants/Lookup';
import {submissionEnd} from '../CommonActions/commonActions';
const initialData = {
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  addRuleGroupStatus: null,
  addFilterRuleGroupStatus: null,
  addUsageFilterRuleGroupStatus: null,
  ruleGroupData: {},
  filterRuleGroupData: {},
  usageFilterRuleGroupData: {},
  userMetrix: '',
  addSuccessMsg: null,
  addRuleData: {},
  addRuleStatus: null,
  testRuleGroupStatus: null,
  resultByTest: '',
  testResponse: {},
  testFilterResponse: [],
  ruleGroupPrintStatus: null,
  formulaUsageResponse: {},
  allCodeAndDisplayName: [],
  allFilterCodeAndDisplayName: [],
  addHeaderStatus: null,
  basicInfoData: {},
  expressionRuleStatus: null,
  category: '',
  formData: {},
  statusCode: null,
  id: null,
  iscopyLoading: false,
  copyFormulaStatus: null,
  copySuccessMsg: null,
  copyErrorMsg: null,
  copyId: null,
  isFormulaRuleLoading: false,
  testErrorMsg: false,
  addFormulaFieldsStatus: null,
  FormulaFieldsData: [],
  mapFieldListStatus: null,
  mapFieldsData: [],
  allFunctions: null,
  functionDetails: null,
  formulaFieldsData: [],
  operatorsDropdownData: [],
  downloadSuccessMessage: null,
  configurationUrl: '',
  dockey: '',
  dmActions: [],
  filterRuleId: null,
};

const slice = createSlice({
  name: 'addRuleGroup',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
      state.successMsg = null;
    },
    fetchFormulaRuleStart: (state) => {
      state.isFormulaRuleLoading = true;
      state.errorMsg = null;
      state.successMsg = null;
    },
    getBasicInfoData: (state, action) => {
      state.basicInfoData = action.payload?.response;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
    },
    setReduxState: (state, action) => {
      state[action.payload.property] = action?.payload?.value;
    },
    postHeaderData: (state, action) => {
      state.addHeaderStatus = action.payload?.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.message;
      state.reportCode = action.payload?.response?.reportCode;
      state.statusCode = action.payload.status;
      state.id = action?.payload?.response?.id;
    },
    postRuleGroupData: (state, action) => {
      state.addRuleGroupStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
      state.userMetrix = action.payload.response.userMetrix;
    },
    postTestRuleGroupData: (state, action) => {
      state.testResponse = action.payload;
      state.resultByTest = action.payload.response[0];
      state.testRuleGroupStatus = action.payload.status;
    },
    resetTestData: (state, action) => {
      state.testResponse = null;
      state.resultByTest = null;
      state.testRuleGroupStatus = null;
      state.testErrorMsg = null;
    },
    postTestFilterRuleGroupData: (state, action) => {
      state.testFilterResponse = action.payload.response;
      state.isLoading = false;
      state.errorMsg = null;
      // state.testResponse = action.payload
      // state.resultByTest = action.payload.response[0]
      // state.testRuleGroupStatus = action.payload.status;
    },
    postReportFiltersData: (state, action) => {
      state.testFilterResponse = action.payload.response;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postFilterRuleGroupData: (state, action) => {
      state.addRuleGroupStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.filterRuleId = action.payload?.response?.id;
      // state.successMsg = action.payload.message;
      state.addRuleData = action.payload.response.placeResponse;
      state.userMetrix = action.payload.response.userMetrix;
    },
    resetFilterRuleId:(state, action) => {
      state.filterRuleId = null;
    },
    postRuleAddData: (state, action) => {
      state.addRuleStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.addRuleData = action.payload.response.placeResponse;
      state.addSuccessMsg = action.payload.message;
      state.userMetrix = action.payload.response.userMetrix;
    },
    getRuleGroupData: (state, action) => {
      state.basicInfoData = action.payload;
      state.isLoading = false;
      state.isFormulaRuleLoading = false;
      state.errorMsg = null;
      state.addRuleGroupStatus = action.payload.status;
      state.successMsg = action.payload.response;
      state.id = action.payload?.groupId;
    },
    getOverrideRuleData: (state, action) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.addRuleStatus = action.payload.status;
      state.addRuleData = action.payload.response.placeResponse;
      state.userMetrix = action.payload.response.userMetrix;
    },
    getUsageFilterRuleGroup: (state, action) => {
      state.usageFilterRuleGroupData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.addUsageFilterRuleGroupStatus = action.payload.status;
      state.successMsg = action.payload.response;
    },
    getFilterRuleGroupData: (state, action) => {
      state.filterRuleGroupData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.addFilterRuleGroupStatus = action.payload.status;
      state.successMsg = action.payload.response;
    },
    getFormulaRuleGroupUsageData: (state, action) => {
      state.formulaUsageResponse = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    getMapFieldsData: (state, action) => {
      (state.mapFieldsData = action.payload), (state.isLoading = false);
      state.successMsg = null;
      state.errorMsg = null;
    },
    fetchCopy: (state) => {
      state.iscopyLoading = true;
      state.errorMsg = null;
    },
    postCopyFormulaData: (state, action) => {
      state.copyFormulaStatus = action.payload?.status;
      state.iscopyLoading = false;
      state.copySuccessMsg = action.payload?.message;
      state.copyErrorMsg = null;
      state.copyId = action.payload?.response?.groupId;
    },
    postFormulaFieldsData: (state, action) => {
      state.addFormulaFieldsStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.message;
    },
    getFormulaFieldsData: (state, action) => {
      state.formulaFieldsData = action.payload?.response?.formulaFieldsRequest;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchDropDownData: (state, action) => {
      state.operatorsDropdownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchActionsDropdownData: (state, action) => {
      state.dmActions = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    resetMsg: (state) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
      state.addFormulaFieldsStatus = null;
      state.formulaFieldsData = [];
    },
    postMapFieldsData: (state, action) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
      state.mapFieldListStatus = action.payload?.status;
    },
    fetchCopyError: (state, action) => {
      state.copyErrorMsg = action.payload;
      state.iscopyLoading = false;
    },

    fetchSuccess: (state, action) => {
      state.statusCode = action.payload.status;
      state.successMsg = action.payload.message;
      state.isLoading = false;
    },
    fetchDeleteSuccess: (state, action) => {
      state.successMsg = action.payload.response;
      state.isLoading = false;
    },
    fetchAddSuccess: (state, action) => {
      state.addSuccessMsg = action.payload.message ?
        action.payload.message :
        action.payload.response ?
          action.payload.response :
          '';
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.message ?
        action?.payload?.data?.message :
        action?.payload?.data?.error ?
          action?.payload?.data?.error :
          action?.payload ?
            action?.payload :
            '';
      state.isLoading = false;
      state.statusCode = action?.payload?.data?.status ? action?.payload?.data?.status : null;
    },
    fetchTestError: (state, action) => {
      state.testErrorMsg = action?.payload?.data?.message ?
        action?.payload?.data?.message :
        action?.payload?.data?.error ?
          action?.payload?.data?.error :
          action?.payload ?
            action?.payload :
            '';
      state.isLoading = false;
    },
    setFunctionsData: (state, action) => {
      state.allFunctions = action?.payload;
      state.isLoading = false;
    },
    setFunctionDetails: (state, action) => {
      state.functionDetails = action.payload;
      state.isLoading = false;
    },
    resetStatus: (state, action) => {
      state.addRuleGroupStatus = null;
      state.isLoading = false;
      state.ruleGroupData = {};
      state.filterRuleGroupData = {};
      state.addFilterRuleGroupStatus = null;
      state.testRuleGroupStatus = null;
      state.addUsageFilterRuleGroupStatus = null;
      state.mapFieldListStatus = null;
      state.mapFieldsData = [];
    },

    resetMessage: (state, action) => {
      state.successMsg = null;
      state.isLoading = false;
      state.errorMsg = null;
      state.printStatus = null;
      state.statusCode = null;
    },
    resetTest: (state, action) => {
      state.successMsg = null;
      state.isLoading = false;
      state.errorMsg = null;
    },

    resetRuleStatus: (state, action) => {
      state.addRuleStatus = null;
      state.addSuccessMsg = null;
      state.successMsg = null;
    },
    resetTestRuleGroupStatus: (state, action) => {
      state.testRuleGroupStatus = null;
    },
    resetData: (state, action) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
      state.addRuleGroupStatus = null;
      state.ruleGroupData = {};
      state.filterRuleGroupData = {};
      state.mapFieldsData = [];
      state.mapFieldListStatus = null;
    },
    resetusageRuleGroup: (state, action) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
      state.usageFilterRuleGroupData = {};
    },
    resetformulaUsagedata: (state, action) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
      state.formulaUsageResponse = {};
    },
    setruleGroupPrintData: (state, action) => {
      state.ruleGroupPrintStatus = action.payload.status;
      state.successMsg = action.payload.response;
      state.isLoading = false;
    },
    setruleGroupExpression: (state, action) => {
      state.expressionRuleStatus = action.payload.status;
      state.successMsg = action.payload.response;
      state.isLoading = false;
    },
    resetPrintRuleGroupStatus: (state) => {
      state.ruleGroupPrintStatus = null;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
      state.downloadSuccessMessage = null;
    },
    printSuccess: (state, action) => {
      state.printStatus = action.payload.status;
      state.downloadSuccessMessage = action.payload.response;
      state.isLoading = false;
    },
    testFilterResetData: (state, action) => {
      state.testFilterResponse = [];
    },
    getAllCodeAndDisplayName: (state, action) => {
      state.allCodeAndDisplayName = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getAllFilterCodeAndDisplayName: (state, action) => {
      state.allFilterCodeAndDisplayName = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    resetRuleGroupData: (state, action) => {
      state.filterRuleGroupData = {};
      state.basicInfoData = {};
      state.category = '';
      state.formData = '';
      state.statusCode = '';
      state.id = '';
    },
    resetCopyFormulaData: (state, action) => {
      state.copyFormulaStatus = null;
      state.iscopyLoading = false;
      state.copySuccessMsg = null;
      state.copyErrorMsg = null;
    },
    setConfigUrl: (state, action) => {
      state.isLoading = false;
      state.configurationUrl = action.payload;
    },
    resetConfigUrl: (state, action) => {
      state.configurationUrl = '';
    },
    resetDockey: (state, action) => {
      state.dockey = '';
    },
    setDockey: (state, action) => {
      state.isLoading = false;
      state.dockey = action.payload;
    },
  },
});

export default slice.reducer;

// Actions

export const {
  fetchStart,
  postHeaderData,
  postRuleGroupData,
  getRuleGroupData,
  fetchFormulaRuleStart,
  getUsageFilterRuleGroup,
  fetchSuccess,
  fetchError,
  resetMessage,
  resetTest,
  resetStatus,
  resetData,
  resetRuleStatus,
  postRuleAddData,
  fetchAddSuccess,
  postTestRuleGroupData,
  postFilterRuleGroupData,
  getFilterRuleGroupData,
  resetTestRuleGroupStatus,
  postTestFilterRuleGroupData,
  setruleGroupPrintData,
  setruleGroupExpression,
  resetPrintRuleGroupStatus,
  getFormulaRuleGroupUsageData,
  printSuccess,
  testFilterResetData,
  resetformulaUsagedata,
  resetusageRuleGroup,
  getAllCodeAndDisplayName,
  getAllFilterCodeAndDisplayName,
  resetRuleGroupData,
  setReduxState,
  fetchCopy,
  postCopyFormulaData,
  fetchCopyError,
  resetCopyFormulaData,
  fetchDeleteSuccess,
  getOverrideRuleData,
  postReportFiltersData,
  resetTestData,
  fetchTestError,
  postFormulaFieldsData,
  getFormulaFieldsData,
  resetMsg,
  postMapFieldsData,
  getMapFieldsData,
  setFunctionsData,
  setFunctionDetails,
  fetchDropDownData,
  setConfigUrl,
  resetConfigUrl,
  setDockey,
  resetDockey,
  fetchActionsDropdownData,
  resetFilterRuleId,
} = slice.actions;

export const postBasicInfo = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`rules/save/addrule`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200 && data?.response?.userMetrix) {
          dispatch(getOverrideRuleData(data));
          dispatch(fetchAddSuccess(data));
        } else if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(postHeaderData(data));
          // dispatch(fetchSuccess(data));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchAllFunctions = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`rules/get/all/functionname`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(setFunctionsData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};

export const fetchFunctionDetailsById = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`rules/find/datacalnfunction/${id}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(setFunctionDetails(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};

export const fetchFormulaUsage = (groupId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`rules/usage/formularulegroup/${groupId}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getFormulaRuleGroupUsageData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};
export const printFilterRuleGroup = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`rules/print/filterrulegroup`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postPrintWindows({dockey: data?.message}, data));
          dispatch(setDockey(data?.message));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};

export const postPrintWindows = (payload, postRuleGroupData) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`rules/generateurlprintfiltergroup`, payload)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          // dispatch(setruleGroupPrintData(postRuleGroupData));
          // download(data.data);
          dispatch(fetchDownloadSuccess(postRuleGroupData));
          dispatch(setConfigUrl(data?.data || ''));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};
export const postRuleGroup = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`rules/save/addrule`, details)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200 && data?.response?.userMetrix) {
          dispatch(postRuleAddData(data));
          dispatch(fetchAddSuccess(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(postRuleGroupData(data));
          dispatch(fetchSuccess(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postFormulaFields = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`rules/save/formulafields`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(postFormulaFieldsData(data));
          // dispatch(fetchSuccess(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postFormulaSelectFields = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`rules/get/formulafields`, details)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getFormulaFieldsData(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postFormulaRuleGroup = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`rules/print/formularulegroup`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          // dispatch(fetchSuccess());
          dispatch(printFormulaRuleGroup({dockey: data?.message}, data));
          dispatch(setDockey(data?.message));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};

export const printFormulaRuleGroup = (payload, printData) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`rules/generateurlprintfrg`, payload)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          // dispatch(printSuccess(printData));
          // download(data.data);
          dispatch(setConfigUrl(data?.data || ''));
          dispatch(fetchDownloadSuccess(printData));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};
export const postTestRuleGroup = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`rules/test/bre/expressions`, details)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchTestError(data));

          // }else if (data && data.status && data.status === 200 && data?.response?.userMetrix) {
          // dispatch(postRuleAddData(data));
          // dispatch(fetchAddSuccess(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(postTestRuleGroupData(data));
          dispatch(fetchSuccess('success'));
        } else if (data && data.status && data.status === 500 && data.message) {
          dispatch(fetchTestError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postTestFilterRuleGroup = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`rules/test/filtergroup/expressions`, details)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          // dispatch(fetchError(data));
          // }else if (data && data.status && data.status === 200 && data?.response?.userMetrix) {
          // dispatch(postRuleAddData(data));
          // dispatch(fetchAddSuccess(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(postTestFilterRuleGroupData(data));
          dispatch(fetchSuccess('success'));
        } else if (data && data.status && data.status === 500) {
          dispatch(fetchError(data.statusText));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postReportFilterTest = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`reportstransaction/test/reportRule/expressions`, details)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          // dispatch(fetchError(data));
          // }else if (data && data.status && data.status === 200 && data?.response?.userMetrix) {
          // dispatch(postRuleAddData(data));
          // dispatch(fetchAddSuccess(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(postReportFiltersData(data));
          dispatch(fetchSuccess('success'));
        } else if (data && data.status && data.status === 500) {
          dispatch(fetchError(data.statusText));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postFilterRuleGroup = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`rules/save/filterrulegroup`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200 && data?.response?.userMetrix) {
          dispatch(postRuleAddData(data));
          dispatch(fetchAddSuccess(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(postFilterRuleGroupData(data));
          dispatch(fetchSuccess(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchRuleGroup = (groupId) => {
  return (dispatch) => {
    dispatch(fetchFormulaRuleStart());
    httpGet(`rules/find/rules/${groupId}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getRuleGroupData(data.response));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postMapFields = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`rules/save/formulafields`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postMapFieldsData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const usageRuleGroup = (ruleGroupCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`rules/get/usagefilterrulegroup/${ruleGroupCode}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getUsageFilterRuleGroup(data.response));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchMapFields = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`rules/get/formulafields`, details)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getMapFieldsData(data.response));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchFilterRuleGroup = (groupId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`rules/find/filter/rules/${groupId}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getFilterRuleGroupData(data.response));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postCopyFormula = (details) => {
  return (dispatch) => {
    dispatch(fetchCopy());
    httpPost(`rules/save/copy/formula`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postCopyFormulaData(data));
        } else {
          dispatch(fetchCopyError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchCopyError(error.message));
      });
  };
};
export const getOperatorsDropdownData = () => {
  return (dispatch) => {
    httpPost(`lookup/find/all/lookup`, {
      typeCode: ['OPERATORS', DM_ACTIONS],
    })
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchDropDownData(data?.data?.OPERATORS));
          dispatch(fetchActionsDropdownData(data?.data?.DM_ACTIONS));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const ResetStatus = () => {
  return (dispatch) => {
    dispatch(resetStatus());
  };
};
export const ResetMessage = () => {
  return (dispatch) => {
    dispatch(resetMessage());
  };
};

export const ResetTest = (page) => {
  return (dispatch) => {
    dispatch(resetTest(page));
  };
};

export const ResetRuleGroupData = () => {
  return (dispatch) => {
    dispatch(resetRuleGroupData());
  };
};
export const ResetAddRule = () => {
  return (dispatch) => {
    dispatch(resetRuleStatus());
  };
};
export const resetRuleGroupPrintStatus = () => {
  return (dispatch) => {
    dispatch(resetPrintRuleGroupStatus());
  };
};
export const fetchAllCodeAndDisplayName = (data) => {
  return (dispatch) => {
    httpGet(`rules/find/all/groupcodeanddisplayname`)
      .then((data) => {
        if (data?.status && data.status === 200) {
          dispatch(getAllCodeAndDisplayName(data?.response));
        } else {
          dispatch(fetchError(data?.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const fetchFilterAllCodeAndDisplayName = (data) => {
  return (dispatch) => {
    httpGet(`rules/get/all/displaynamegroupcode`)
      .then((data) => {
        if (data?.status && data.status === 200) {
          dispatch(getAllFilterCodeAndDisplayName(data?.response));
        } else {
          dispatch(fetchError(data?.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const postRuleExpression = (payload) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`rules/validate/rule`, payload)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchSuccess(data));
          dispatch(setruleGroupExpression(postRuleGroupData));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};

export const resetFormula = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};

export const resetCopyFormula = () => {
  return (dispatch) => {
    dispatch(resetCopyFormulaData());
  };
};

export const resetTestResult = () => {
  return (dispatch) => {
    dispatch(resetTestData());
  };
};
